import { IdAssetBundleBalancing } from "../features/balancing/IdAssetBundleBalancing";
var cities = {
    convertToMap: false,
    dataExtractor: function (data) { return data.data.list.farm; },
    id: IdAssetBundleBalancing.Farms,
};
var constants = {
    convertToMap: false,
    dataExtractor: function (data) { return data.data; },
    id: IdAssetBundleBalancing.Constants,
};
var expansions = {
    convertToMap: false,
    dataExtractor: function (data) { return data.data.list.expansionGroup; },
    id: IdAssetBundleBalancing.Expansions,
};
var buildings = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.building; },
    id: IdAssetBundleBalancing.Buildings,
};
var resources = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.resource; },
    id: IdAssetBundleBalancing.Resources,
};
var quests = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.quest; },
    id: IdAssetBundleBalancing.Quests,
};
var questIntros = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.quests; },
    id: IdAssetBundleBalancing.QuestIntros,
    mapKeyProp: "questId",
};
var recipes = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.recipe; },
    id: IdAssetBundleBalancing.Recipes,
};
var playerLevels = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.playerlevel; },
    id: IdAssetBundleBalancing.PlayerLevels,
};
var UIElements = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.uiElement; },
    id: IdAssetBundleBalancing.UiDefinitions,
};
var contractOrders = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.contractOrder; },
    id: IdAssetBundleBalancing.ContractOrders,
};
var contractRewards = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.contractReward; },
    id: IdAssetBundleBalancing.ContractRewards,
};
var characters = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.character; },
    id: IdAssetBundleBalancing.Characters,
};
var outskirts = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.outsideBuilding; },
    id: IdAssetBundleBalancing.Outskirts,
};
var farmEvents = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.farmEvent; },
    id: IdAssetBundleBalancing.FarmEvents,
};
var profilePictures = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.profilePicture; },
    id: IdAssetBundleBalancing.ProfilePictures,
};
var purchaseOfferGroups = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.purchaseOfferGroup; },
    id: IdAssetBundleBalancing.PurchaseOfferGroups,
    mapKeyProp: "purchaseOfferCharacteristicId",
};
var purchaseOfferShiftLevels = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.purchaseOfferShiftlevel; },
    id: IdAssetBundleBalancing.PurchaseOfferShiftLevels,
    mapKeyProp: "shiftlevel",
};
var randomPools = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.randomPool; },
    id: IdAssetBundleBalancing.RandomPools,
};
var packages = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list._package; },
    id: IdAssetBundleBalancing.Packages,
};
var coopLevels = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.cooplevel; },
    id: IdAssetBundleBalancing.CoopLevels,
};
var coopSettings = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.coopSetting; },
    id: IdAssetBundleBalancing.CoopSettings,
};
var coopProjects = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.coopProject; },
    id: IdAssetBundleBalancing.CoopProjects,
};
var languageSettings = {
    convertToMap: false,
    dataExtractor: function (data) { return data.data.list.languageSetting; },
    id: IdAssetBundleBalancing.LanguageSettings,
};
var libraryImprovements = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.libraryImprovement; },
    id: IdAssetBundleBalancing.LibraryImprovements,
};
var marketImprovements = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.marketImprovement; },
    id: IdAssetBundleBalancing.MarketImprovements,
};
var buffs = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.buff; },
    id: IdAssetBundleBalancing.Buffs,
};
var balloonOfferContents = {
    convertToMap: true,
    dataExtractor: function (data) { return data.data.list.balloonOfferContent; },
    id: IdAssetBundleBalancing.BalloonOfferContents,
};
var pvpMapDefinitions = {
    convertToMap: true,
    dataExtractor: function (data) {
        return data.data.list.pvpMapDefinition;
    },
    id: IdAssetBundleBalancing.PVPMapDefinitions,
};
export var balancingConfigInitial = [
    cities,
    constants,
    coopLevels,
    coopSettings,
    coopProjects,
    expansions,
    buildings,
    resources,
    quests,
    questIntros,
    recipes,
    playerLevels,
    UIElements,
    contractOrders,
    contractRewards,
    characters,
    outskirts,
    farmEvents,
    profilePictures,
    purchaseOfferGroups,
    purchaseOfferShiftLevels,
    randomPools,
    packages,
    languageSettings,
    libraryImprovements,
    marketImprovements,
    buffs,
    balloonOfferContents,
    pvpMapDefinitions,
];



//////////////////
// WEBPACK FOOTER
// ./src/setup/balancingConfigInitial.ts
// module id = 2512
// module chunks = 3